<form #scoutPointEnvForm="ngForm" class="scout-pt-form p-0">

    <div *ngIf="scoutPoint?.envData">
        
        <table class="w-100 env-field-table table table-striped table-condensed">
            <tbody>
            <tr *ngIf="showTitlebar"> 
                <td colspan="9" class="text-center" style="color: white; font-weight: bold;" [ngStyle]="{'background-color': scoutPoint.color}">
                    Environment {{scoutPoint.name}}
                </td>
                <td class="text-center" style="width: 1em; font-weight: bold;">
                    {{scoutPoint.type}}
            </td>
            </tr>

            <tr>
                <th style="width: 5em;">Point Description</th>
                <td *ngIf="!isEditing" colspan="9" class="w-100" role="button" (click)="onValueClicked()">
                    {{scoutPoint.envData.pointDescription}}
                </td>
                <td *ngIf="isEditing" colspan="9" class="w-100">
                    <textarea name="pointDescription" type='text' class="w-100" rows="2" placeholder="point description"
                        [(ngModel)]="scoutPoint.envData.pointDescription" #pointDescription="ngModel" 
                        [ngClass]="{ 'invalid-input': pointDescription.invalid && (pointDescription.dirty || pointDescription.touched)}" >
                    </textarea>
                </td>
            </tr>

            <tr>
                <th>HVAC</th>
                <td *ngIf="!isEditing" colspan="9" role="button" (click)="onValueClicked()">
                    {{scoutPoint.envData.hvacDescription}}
                </td>
                <td *ngIf="isEditing" colspan="9">
                    <textarea name="hvacDescription" type='text' class="w-100" rows="1" placeholder="hvac description"
                        [(ngModel)]="scoutPoint.envData.hvacDescription" #hvacDescription="ngModel" 
                        [ngClass]="{ 'invalid-input': hvacDescription.invalid && (hvacDescription.dirty || hvacDescription.touched)}" >
                    </textarea>
                </td>
            </tr>

            <tr>
                <th>Clutter</th>
                <td *ngIf="!isEditing" colspan="9" role="button" (click)="onValueClicked()">
                    {{scoutPoint.envData.clutterDescription}}
                </td>
                <td *ngIf="isEditing" colspan="9">
                    <textarea name="clutterDescription" type='text' class="w-100" rows="1" placeholder="clutter description"
                        [(ngModel)]="scoutPoint.envData.clutterDescription" #clutterDescription="ngModel" 
                        [ngClass]="{ 'invalid-input': clutterDescription.invalid && (clutterDescription.dirty || clutterDescription.touched)}" >
                    </textarea>
                </td>
            </tr>

            <tr><th colspan="10" class="p-sm-1"> </th></tr>
            <!-- Using window count row to define column width of 2nd column of table -->
            <tr>
                <th>Window Count</th>
                <td *ngIf="!isEditing" role="button" (click)="onValueClicked()">
                    {{scoutPoint.envData.windowCount}}
                </td>
                <td *ngIf="isEditing">
                    <input name="windowCount" type='number' step="1" [min]="0" style="width: 5em;"
                        [(ngModel)]="scoutPoint.envData.windowCount" #windowCount="ngModel" digits
                        [ngClass]="{ 'invalid-input': windowCount.invalid && (windowCount.dirty || windowCount.touched)}" >
                </td>
                <th class="text-left">
                    within 7.62m (25ft)'
                </th>
                <th class="pl-3">Nearest Window</th>
                <td *ngIf="!isEditing" role="button" (click)="onValueClicked()">
                    {{scoutPoint.envData.nearestWindowDistance}}
                </td>
                <td *ngIf="isEditing">
                    <input name="nearestWindowDistance" type='number' [min]="0" style="width: 5em;"
                        [(ngModel)]="scoutPoint.envData.nearestWindowDistance" #nearestWindowDistance="ngModel" number
                        [ngClass]="{ 'invalid-input': nearestWindowDistance.invalid && (nearestWindowDistance.dirty || nearestWindowDistance.touched)}" >
                </td>
                <th class="text-left">
                    meters
                </th>
                <th class="pl-3">Floor to Ceiling</th>
                <td *ngIf="!isEditing" role="button" (click)="onValueClicked()">
                    {{scoutPoint.envData.floorToCeilingHeight}}
                </td>
                <td *ngIf="isEditing">
                    <input name="floorToCeilingHeight" type='number' [min]="0" style="width: 5em;"
                        [(ngModel)]="scoutPoint.envData.floorToCeilingHeight" #floorToCeilingHeight="ngModel" number
                        [ngClass]="{ 'invalid-input': floorToCeilingHeight.invalid && (floorToCeilingHeight.dirty || floorToCeilingHeight.touched)}" >
                </td>
                <th class="text-left">
                    meters
                </th>
            </tr>
            
            <tr><th colspan="10" class="p-sm-1"> </th></tr>
            
            <tr>
                <th>Type</th>
                <td *ngIf="!isEditing" colspan="2" role="button" (click)="onValueClicked()">
                    {{scoutPoint.envData.bInterior?"Interior":"Exterior"}}
                </td>
                <td *ngIf="isEditing" colspan="3" style="font-size:12px;">
                    <div class="form-check-inline">
                        <label>
                            <input type="radio" name="isInterior" [value]="true" [(ngModel)]="scoutPoint.envData.bInterior">
                            Interior
                        </label>
                    </div>
                    <div class="form-check-inline">
                        <label>
                            <input type="radio" name="isInterior" [value]="false" [(ngModel)]="scoutPoint.envData.bInterior">
                            Exterior
                        </label>
                    </div>
                </td>
                <th colspan="2"></th>
                <th>Quadrant</th>
                <td *ngIf="!isEditing" colspan="1" role="button" (click)="onValueClicked()">
                    {{scoutPoint.envData.quadrant}}
                </td>
                <td *ngIf="isEditing" colspan="2">
                    <select #quadrantSelect name="quadrantSelect" style="width:4em;" [(ngModel)]="scoutPoint.envData.quadrant">
                        <option *ngFor="let quadrantOption of ['', 'N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW']" [ngValue]="quadrantOption">{{quadrantOption}}</option>
                    </select>
                </td>                
            </tr>
            </tbody>
        </table>
        
    </div>

</form>
